export enum UploadTypes {
  UNKNOWN = 0,
  MODULE = 1,
  SCENE = 2,
  SCENE_PREVIEW = 3,
  USER_CSV = 4,
  COURSE_NODE_IMAGE = 5,
  CERTIFICATE_IMAGE = 6,
  MODULE_PREVIEW = 7,
  SCENE_PORTRAIT_PREVIEW = 8,
  COURSE_PREVIEW = 9,
  VERIFICATION_REQUEST = 10,
  TRANSCRIBE_REQUEST = 11,
  ORG_USER = 12,
  GROUP_USER = 13,
  ORG_LOGO = 14,
  COURSE_USER = 15,
  ORG_USER_VARIABLE = 16,

}
